import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark.jsx";
import SingleBarLineChart from "../../../Components/Charts/singleBarLineChart.js";

const digitalSalesApi = async (body) => {
  try {
    const res = await axInst.post("dealer-review/digital_sales", body);
    return res.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const DigitalSales = () => {
  const { data, submitted } = useSelector((e) => e.filtersDealerReview);

  let {
    data: digitalSales,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["digitalSales", submitted],
    queryFn: () => digitalSalesApi(data),
    cacheTime: 0,
    staleTime: 0,
  });

  digitalSales = digitalSales?.map((item) => {
    const [month, year] = item.MONTH.split("-");
    return {
      ...item,
      MONTH: month, // Only keep the month name
      year: `FY-20${year}`,
    };
  });

  return (
    <div className="bg-white rounded-md p-2 shadow-lg relative h-full">
      <div className="flex justify-between pr-8 items-center">
        <h2 className="text-lg font-bold text-gray-800">
          OSP and Digital Sales
        </h2>
        {digitalSales?.length > 0 && (
          <div className="flex items-center gap-[5px]">
            <span className="w-[10px] h-[10px] bg-green-500 rounded-full mr-2"></span>
            <span className="text-[13px] text-[#464444]">
              {digitalSales[digitalSales.length - 1]?.year}
            </span>
          </div>
        )}
      </div>

      {isFetching && (
        <div className="grid items-center justify-center w-full h-full">
          <Loader />
        </div>
      )}
      {isError && (
        <div className="grid items-center justify-center w-full h-full">
          {/* <p>Error Occurred</p> */}
          <p>Error Occurred: {isError.message}</p>
        </div>
      )}
      {!isFetching && !digitalSales && (
        <div className="grid items-center justify-center w-full h-full">
          <p>Data not available</p>
        </div>
      )}
      <WaterMark />
      <div>
        {digitalSales && (
          <SingleBarLineChart
            heading="OSP and Digital Sales"
            data={digitalSales}
            xKey="MONTH"
            barKey="DIGITAL_PERCENTAGE"
            lineKey="INCREMENTAL_PERCENTAGE"
            title="Digital vs Incremental (%)"
            barLabel="% Sales assisted by OSP and digital"
            lineLabel="Increase in deal visbility through digital Enablement"
            height={190}
          />
        )}
      </div>
    </div>
  );
};
